import { useEffect, useRef } from 'react'
import { useLocation } from 'react-router-dom'

export default function useRybbit(retailer) {
    const location = useLocation()
    const identified = useRef(false)

    useEffect(() => {
        if (import.meta.env.DEV) return
        if (!retailer) return

        const run = () => {
            if (!identified.current) {
                window.rybbit.identify(retailer.public_id, {
                    name: retailer.name,
                })
                identified.current = true
            }

            window.rybbit.pageview()
        }

        if (window.rybbit) {
            run()
        } else {
            const script = document.querySelector('script[data-site-id]')
            if (script) script.addEventListener('load', run, { once: true })
        }
    }, [retailer?.id, location.pathname])
}
